import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./header-tabs.scss";
import {cx} from "emotion";
import {DomSizeObserver} from "../../../../../../../dom-size-observer";
import {ScrollShadow} from "../../../../../../../scroll-shadow/scroll-shadow";
import {ScrollButtons} from "./scroll-buttons/scroll-buttons";
import {ScrollControl} from "../../../../../../../scroll-control";

export const HeaderTabs = ({tabs}) => cs(
    ["outerSize", (_, next) => DomSizeObserver({
        translate: ({width}) => width,
        defaultValue: 1000,
        next,
    })],
    ["innerSize", (_, next) => DomSizeObserver({
        translate: ({width}) => width,
        defaultValue: 600,
        next,
    })],
    ["scrollShadow", (_, next) => ScrollShadow({color: "white", direction: "horizontal", next})],
    ["scrollControl", (_, next) => ScrollControl({next})],
    ["scrollable", ({outerSize, innerSize}, next) => next(innerSize.value >= outerSize.value)],
    ({outerSize, innerSize, scrollable, scrollShadow, scrollControl}) => (
        <div className={cx("header-tabs-1pm")} ref={outerSize.ref}>

            <div
                className="tabs-wrapper"
                ref={(dom) => {
                    scrollShadow.domRef(dom);
                    scrollControl.ref(dom);
                }}
            >
                <div className="tabs" ref={innerSize.ref}>
                    {tabs.map((tab, i) => (
                        <div
                            className={cx("tab", {selected: tab.selected, hasError: tab.hasError})}
                            xd-qa-type="label"
                            xd-qa-name={tab.label}
                            key={i}
                            onClick={() => !tab.selected && tab.onSelect()}
                        >
                            <div className="label">
                                {tab.label}
                            </div>
                            {(tab.badge != null) && (
                                <div className="badge">
                                    ({tab.badge})
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {scrollable && (
                    <div className="spacer-right"/>
                )}
            </div>

            {scrollShadow.render({
                widthLeft: 66,
                widthRight: 120,
                opacity: .8,
                paddingBottom: 3,
            })}

            {scrollable && (
                ScrollButtons({
                    onLeft : () => scrollControl.start("left"),
                    onRight: () => scrollControl.start("right"),
                })
            )}
        </div>
    ),
);
